<div class="main-content">
    <div class="container-fluid">
      <!--<button (click)="getFiles(this.idFolder)" mat-raised-button class="btn btn-success">-->
        <button (click)="doRefresh()" mat-raised-button class="btn btn-success">
                <span class="btn-label">
                  <i class="material-icons">refresh</i>
                </span>
                 Refresh
              </button>

      <div  style="float: right; margin-right: 20px" class="row">
         <button (click)="openNuevoFolder()" mat-raised-button class="btn btn-success">
                <span class="btn-label">
                  <i class="material-icons">create_new_folder</i>
                </span>
                 New Folder
              </button>


             
      </div>
       <button (click)="upFolder()" mat-raised-button  class="btn btn-success">
                <span class="btn-label">
                  <i class="material-icons">publish</i>
                </span>
                 Back
              </button>

              <button *ngIf="this.fullPermission == 1" (click)="downloadAll()" mat-raised-button  class="btn btn-success">
                <span class="btn-label">
                  <i class="material-icons">cloud_download</i>
                </span>
                 Download All
              </button>
      <div class="clearfix"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                  <div class="card-header card/-header-primary card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">folder</i>
                    </div>
                    
                    <h3 class="card-title" style="    font-weight: 600;
    color: darkblue;">You are here: <a style="font-weight: 600;
    color: darkblue;" [routerLink]="['/tables/listfiles']" >home</a>{{this.folderinterno.folderPath}}{{folderinterno.name}}</h3>
   
                  <div style="
    padding: 15px 0 15px 10px;
    border-radius: 6px;
    border: 1px dashed #ccc;
    background-color: #fafafa;
    color: black;">
                    <ul>
                      <li>Folder Name: {{this.folderinterno.name}}</li>
                    </ul>
                    <div >
                        <h3>Permissions</h3>
                    <ul style="list-style: none;">
                      <li id="permi-{{permission.id}}" *ngFor="let permission of permissions"><i style="color: green" class="material-icons">person</i> {{permission.user.name}} {{permission.user.surname}} <i *ngIf="(this.isOwner && this.identity.sub != permission.user.id) || this.identity.role == 'ADMINISTRATOR'" style="color: red" (click)="deletePermiso(permission)" class="material-icons">
delete_forever
</i></li>
                    
                    </ul>
<div id="permisosdiv" *ngIf="this.isOwner ">
  <mat-form-field class="example-full-width">
    <input type="text" [(ngModel)]="this.folderPermissions.user_id" placeholder="Select"  aria-label="Select" matInput [formControl]="myControlClientes" [matAutocomplete]="autoClientes" id="nameCliente">
    <mat-autocomplete  #autoClientes="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredClientes | async" [value]="option">
        
        {{option.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button (click)="selectUserPermission()" class="btn btn-success" >Add user</button>
</div>
                    
<div class="col-md-12">
                        
                       
                    </div>

                    </div>
                    

                  </div>


                  </div>
                    <div class="card-body" style="    margin-top: 25px;">
                      <a *ngIf="this.hasparent == 0" (click)="showsrch()" style="color: green;
    font-weight: 500;cursor: pointer;"> <i class="material-icons">
search
</i> Advanced Search</a>
                      <div *ngIf="this.showsearch == 1" id="container-advanced-search">
                        <form>
                            <input type="text" placeholder="Search text inside the files" class="form-control" [(ngModel)]="this.advancedsearchtext" name="advancedsearchtext" >

                            <button class="btn btn-info" (click)="searchAdvanced()">Search </button>
                          </form>
                        </div>

                     <div id="showMsgSearching" style="display: none;" class="alert alert-info" role="alert">
                      <i style="   color: white;" class="material-icons">
sync
</i> Please wait, searching in progress
                    </div>

                     <div *ngIf="this.showMsgSearchingNotResults == 1" id="showMsgSearchingNotResults" class="alert alert-danger" role="alert">
                      <i style="   color: white;" class="material-icons">
cancel
</i> No records found, please try again
                    </div>

                       <div  *ngIf="this.showsearchResults == 1" class="material-datatables">
                          <table id="datatablesSearch" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                      
                                      <th>{{ dataTableSearch.headerRow[0] }}</th>
                                      
                                      
                                      <th class="disabled-sorting text-right">{{ dataTableSearch.headerRow[1] }}</th>
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr>
                                   
                                      <th>{{ dataTableSearch.footerRow[0] }}</th>
                                     
                                     
                                      <th class="text-right">{{ dataTableSearch.footerRow[1] }}</th>
                                    </tr>
                                </tfoot>
                                <tbody>
                                    <tr *ngFor="let row of dataTableSearch.dataRows" id="file{{row[0]}}">
                                    
                                        <td>{{row[1]}}</td>
                                       
                                        <td class="text-right">
                                           <a  (click)="goFolder(row[2])"><button mat-raised-button class="btn btn-info">Open Folder</button></a>
                                          <a (click)="openFile(row[0])" target="_blank" ><button mat-raised-button class="btn btn-info">View File</button></a>
                                          <button (click)="downloadFile(row[0])" mat-raised-button  class="btn btn-success">
                
                 Download
              </button>
                                         
                                       
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                          
                        </div>


                        <div id="posearch"> <!-- inicia PO Search -->
                        <!--  <a (click)="showposrch()" style="color: green;
    font-weight: 500;cursor: pointer;"> <i class="material-icons">
search
</i> PO Search</a>-->
                      <div *ngIf="this.showposearch == 1" id="container-po-search">
                        <form>
                            <input type="text" placeholder="Search PO" class="form-control" [(ngModel)]="this.advancedpotext" name="advancedpotext" >

                            <button class="btn btn-info" (click)="searchPO()">Search </button>
                          </form>
                        </div>

                     <div id="showMsgPOSearching" style="display: none;" class="alert alert-info" role="alert">
                      <i style="   color: white;" class="material-icons">
sync
</i> Please wait, searching in progress
                    </div>

                     <div *ngIf="this.showMsgPOSearchingNotResults == 1" id="showMsgPOSearchingNotResults" class="alert alert-danger" role="alert">
                      <i style="   color: white;" class="material-icons">
cancel
</i> No records found, please try again
                    </div>

                       <div  *ngIf="this.showsearchPOResults == 1" class="material-datatables">
                          <table id="datatablesPOSearch" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                      
                                      <th>{{ dataTablePOSearch.headerRow[0] }}</th>
                                      
                                      
                                      <th class="disabled-sorting text-right">{{ dataTablePOSearch.headerRow[1] }}</th>
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr>
                                   
                                      <th>{{ dataTablePOSearch.footerRow[1] }}</th>
                                     
                                     
                                      <th class="text-right">{{ dataTablePOSearch.footerRow[1] }}</th>
                                    </tr>
                                </tfoot>
                                <tbody>
                                    <tr *ngFor="let row of dataTablePOSearch.dataRows" id="file{{row[0]}}">
                                    
                                        <td>{{row[1]}}</td>
                                       
                                        <td class="text-right">
                                           <a  (click)="goFolder(row[0])"><button mat-raised-button class="btn btn-info">Open Folder</button></a>
                                         
                                       
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                          
                        </div>

                        </div><!-- end PO Search -->

                        <div *ngIf="loading">
                          loading....
                        </div>
                          
                        <div class="toolbar">
                            <!--        Here you can write extra buttons/actions for the toolbar              -->
                        </div>
                         <div class="material-datatables">
                          <table *ngIf="contarFolders != 0" id="datafolders" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                      <th style="width: 10px">{{ dataFolder.headerRow[1] }}</th>
                                      <th style="width: 20px" class="disabled-sorting">{{ dataFolder.headerRow[0] }}</th>
                                      
                                      <th>{{ dataFolder.headerRow[2] }}</th>
                                     
                                      <th>{{ dataFolder.headerRow[5] }}</th>
                                      <th class="disabled-sorting text-right">{{ dataFolder.headerRow[4] }}</th>
                                    </tr>
                                </thead>
                          
                                <tbody>
 
                                    <tr id="folder{{row[0]}}" style="background-color: beige;" *ngFor="let row of dataFolder.dataRows">
                                       <td class="text-left">{{row[0]}}</td>
                                        <td><i class="material-icons">
folder
</i></td>
<td class="text-left">{{row[1]}}</td>
                                     
                                  <!-- <td>{{row[4] | date:'MM-dd-yyyy' }}</td>   -->
                                       <td></td> 


                                        <td class="text-right">
                                          <a  (click)="goFolder(row[0])"><button mat-raised-button class="btn btn-info">Open</button></a>
                                         
                                          <a (click)="deleteFolderfirst(row[0])"  class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <input type="hidden" name="borrarFolder" value="" id="borrarFolder" (click)="deleteFolder()">
                        </div>

<div class="row">
                <div id="divFiles" class="files">
                </div>
            </div>
<mat-progress-bar style="width: 80%" *ngIf="loading" id="loadingbar" mode="indeterminate"></mat-progress-bar>

<style type="text/css">
  .resp-container {
    position: relative;
    overflow: hidden;
    padding-top: 30.25%;
}
.resp-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
</style>

<div style="height: 300px;" class="resp-container">
    <iframe class="resp-iframe" [src]='(this.urlUpload)' scrolling="no" allow="encrypted-media" allowfullscreen></iframe>
</div>


                        <div  *ngIf="this.fullPermission == 1 && this.contarFiles != 0" class="material-datatables">
                          <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                      
                                      <th>{{ dataTable.headerRow[1] }}</th>
                                       <th>{{ dataTable.headerRow[2] }}</th>
                                      
                                      <th class="disabled-sorting text-right">{{ dataTable.headerRow[3] }}</th>
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr>
                                   
                                      <th>{{ dataTable.footerRow[1] }}</th>
                                      <th>{{ dataTable.headerRow[2] }}</th>
                                     
                                      <th class="text-right">{{ dataTable.footerRow[3] }}</th>
                                    </tr>
                                </tfoot>
                                <tbody>
                                    <tr *ngFor="let row of dataTable.dataRows" id="file{{row[0]}}">
                                    
                                        <td>{{row[1]}}</td>
                                        <td>{{row[2].timestamp * 1000 | date }}</td>
                                     
                                       
                                        <td class="text-right">
                                          <a (click)="openFile(row[0])" target="_blank" ><button mat-raised-button class="btn btn-info">View</button></a>
                                          <button (click)="downloadFile(row[0])" mat-raised-button  class="btn btn-success">
                
                 Download
              </button>
                                         
                                          <a (click)="deleteFile(row[0])" *ngIf="this.privilegio.level == 'ADMINISTRATOR'  || this.isOwner" class="btn btn-link btn-danger btn-just-icon remove"><i class="material-icons">close</i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <input type="hidden" name="borrarUser" value="" id="borrarUser" (click)="deleteUser()">
                        </div>
                    </div>
                    <!-- end content-->
                </div>
                <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
        </div>
        <!-- end row -->
    </div>
</div>


